import axios from "axios";
import config from "src/config";

const URLDELIVERRESPONSE = config.url.URLDELIVERRESPONSE;

export const MessagesAPI = {
  async notifyDesktop(contextData, requestData) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'customer': contextData.clientId,
        'session-id': contextData.sessionId,
        'sso': contextData.cookie
      }
      const response = await axios.post(URLDELIVERRESPONSE, requestData, { headers });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  }
};
